import { z } from "zod";
import { VerificationSectionId } from "./verification/verification-sections";

export enum ProviderPageTab {
  Verification = "verification",
  Credentials = "credentials",
  /** The credential vault's files. */
  Documents = "documents",
}

/** What starting a run reported, shown on the run's report until it finishes. */
export enum StartedRunNotice {
  DispatchPending = "dispatch-pending",
  Reused = "reused",
}

export const providerPageSearchSchema = z.object({
  tab: z.nativeEnum(ProviderPageTab).optional(),
  section: z.nativeEnum(VerificationSectionId).optional(),
  /** A specific run's report; the latest run when absent. */
  run: z.string().uuid().optional(),
  notice: z.nativeEnum(StartedRunNotice).optional(),
});

export type ProviderPageSearch = z.infer<typeof providerPageSearchSchema>;
